<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'pessoaCrud'"
          crudName="Pessoas"
          newText="Nova Pessoa"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableActive="false"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      unidades: [],
      table: "pessoaTable",
      showMessageImport: false,
      cboCrud: {},
      pages: [],
      url: "",
      columns: ["id", "unidade_id", "nome", "actions"],
      tableData: ["id", "unidade_id", "nome"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "unidade_id", "nome", 'ativo'],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          unidade_id: "Unidade",
          nome: "Nome",
          ativo: "Ativo",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          unidade_id: [],
        },
        templates: {
          unidade_id: function (h, row, index) {
            return row.unidade ? row.unidade.nome : 'Não disponível';
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ['unidade'];

          return this.$http.get(this.url + "?orderByDesc=id&" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "pessoas/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        unidade_id: "unidade_id",
        nome: "nome",
        ativo: "ativo",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    getUnidades: function () {
        const self = this;
        const api = self.$store.state.api + "unidades";
  
        axios
          .get(api)
          .then((response) => {
            response.data.data.forEach(unidade => {
              self.unidades.push({id: unidade.id, text: unidade.nome});
            });
  
            self.options.listColumns.unidade_id = self.unidades;
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      },
  },
  mounted: function () {
    const self = this;

    self.getUnidades();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>